import React from "react";
import db from "../../../../constants/database";

const WhyChooseUs: React.FC = () => {
  return (
    <div className="font-abel bg-[#F1F3F7] py-10 md:py-20">
      <div className="max-w-[1000px] mx-auto px-3 w-full h-full">
        <div className="text-center max-w-[850px] mx-auto pb-5">
          <h2 className="text-[24px] md:text-[50px] text-[#222222]">
            Why Clients Choose This Package
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {db?.whyUs.list?.map((item) => (
            <div className="col-span-1">
              <div key={item.id} className={`mb-4 max-w-[480px]`}>
                <div className="flex items-start">
                  <div className="h-[44.41px] w-[44.41px]">
                    <img
                      src={item.icon}
                      alt="25th and Staffing"
                      className=" w-full"
                    />
                  </div>
                  <div className="ml-3">
                    <p className="text-[14px] md:text-[17px] font-medium text-[#222222] pb-1">
                      {item.text}
                    </p>
                    <p className="text-[14px] md:text-[14.8px] text-[#4E4E4E]">
                      {item.subtitle}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="max-w-[600px] mx-auto pt-10">
          <div className="bg-[#243677] rounded-[7.4px] py-7 px-7 duration-300 text-[white]">
            <div className="mb-3">
              <p className="text-[18px] md:text-[30px]">{db.whyUs.title}</p>
            </div>
            {db.whyUs.note.map((item) => (
              <div key={item.id} className="flex items-center my-2">
                <img src={item.icon} alt="25th and Staffing" />
                <p className="text-[14px] md:text-[17px] ml-3">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
